import { observable, decorate, computed } from 'mobx';
import AllInputsStore from './AllInputsStore';
import AllInputsBlocksStore from './AllInputsBlockStore';
import CookieStore from "./CookieStore";
import axios from 'axios';
const qs = require('qs');

const sha256 = require('js-sha256');




function classNames(classes) {
  return Object.entries(classes)
    .filter(([key, value]) => value)
    .map(([key, value]) => key)
    .join(' ');
}


class mainStore {
  response = null;
  error = null;
  isShowInput = true;
  isResponsePending = false

  constructor() {
    this.CookieStore = new CookieStore();
    this.AllInputsStore = new AllInputsStore(this.CookieStore);
    this.AllInputsBlocksStore = new AllInputsBlocksStore();
  };

  get submitBtnClass() {
    return classNames({
      'btn': true,
      'btn_primary': true,
      'btn_state_pending': this.isResponsePending,
    });
  }


  cancelSubmit = (e) => e.preventDefault();


  submitData = ({name, value}) => {
    if(!this.AllInputsStore.checkAllInput()) {
      return;
    };
    const inputs = this.AllInputsStore.inputs;
    this.isResponsePending = true;
    const paramsObject = this.params;
    const headersObject = this.headers;
    const beforeUrl = 'https://cors.pokerserversoftware.com/';
    const url = beforeUrl + this.url;
    const data = {};
    const contentType = inputs['contenttype'].value;
    for (let key in paramsObject) {
      data[key] = paramsObject[key];
    }
    const formatData = contentType === 'url' ? qs.stringify(data) : data;

    this.response = null;
    this.error = null;
    const config = {
       method: 'post',
       url: url,
       headers: headersObject,
       data : formatData
     };

     axios(config)
     .then(response => {
       this.isResponsePending = false;
       this.response = response;
     })
     .catch((error) => {
       this.isResponsePending = false;
       if(!error) return;
       this.error = error;
     });
    }

  useGeneratedSign = () => {
    this.AllInputsStore.updateInputValue('sign', this.sign);
  };

  get btnClassName() {
    const classes = {
      'btn': true,
      'btn_primary': true,
      'btn_pending': this.isResponsePending,
    }
    return classNames(classes);
  };



  get isShowInputList() {
    if(this.response || this.error) return true;
    return true;
  }

  get stringNoSecretKey() {
    const params = this.sortedUserParams;
    let stringBeforeHash = '';
    for(let name in params) {
      stringBeforeHash += params[name];
    }
    return stringBeforeHash;
  }
  get stringBeforeHash() {
    const inputs = this.AllInputsStore.inputs;
    let stringBeforeHash = this.stringNoSecretKey;
    const secretKey = inputs['secretKey'].value;
    stringBeforeHash += secretKey;
    return stringBeforeHash;
  };

  get params() {
    const inputs = this.AllInputsStore.inputs;
    const inputsBlocks = this.AllInputsBlocksStore.inputsBlocks;
    const paramsBlock = inputsBlocks['params'];
    const paramsBlockName = paramsBlock.inputsNames;
    const paramsObj = {};

    const excludes = ['userId', 'clientId'];
    paramsBlockName.forEach((name) => {
      const {label, value, values, type} = inputs[name];
      if(value === '') return;
      if(excludes.includes(name)) return;
      if(type === 'select') {
        paramsObj[label] = values[value];
      } else {
        paramsObj[label] = value;
      }
    });
    return paramsObj;
  }


  get userParams() {
    const inputs = this.AllInputsStore.inputs;
    const result = {
      clientId: inputs['clientId'].value,
      userId: inputs['userId'].value,
    };
    for(let key in this.params) {
      result[key] = this.params[key];
    }

    return result;
  }

  get sortedUserParams() {
    const result = {};
    const inputBlockNames = Object.keys(this.userParams);
    const sortedInputBlockNames = inputBlockNames.sort();
    sortedInputBlockNames.forEach(name => {
      result[name] = this.userParams[name];
    });
    delete result['clientId'];
    delete result['sign'];
    return result;
  }

  get sortedUserParamsAndSK() {
    const inputs = this.AllInputsStore.inputs;
    const result = Object.assign(this.sortedUserParams);
    result['secretKey'] = inputs['secretKey'].value;
    return result;
  }

  get sign() {
    return sha256(this.stringBeforeHash);
  }

  getQueryURL = (url, params) => {
    const paramsString = Object
        .keys(params)
        .map(k => {
          if (Array.isArray(params[k])) {
            return params[k]
                .map(val => `${encodeURIComponent(k)}[]=${encodeURIComponent(val)}`)
                .join('&')
          }

          return `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`
        })
        .join('&');

    const queryURL = `${url}?${paramsString}`;
    return queryURL;
  }

  get url() {
    const inputs = this.AllInputsStore.inputs;
    const userId = inputs['userId'].value;
    const clientId = inputs['clientId'].value;
    let apiEndpoint = inputs['api'].value;
    if(apiEndpoint[apiEndpoint.length - 1] !== '/' && apiEndpoint.length !== 0) {
      apiEndpoint += '/';
    }
    const contentType = inputs['contenttype'].value;
    const params = Object.assign({}, this.userParams);
    delete params.userId;
    delete params.sign;
    const url = `${apiEndpoint}v2/app/users/${userId}/session?clientId=${clientId}`;
    return url.trim();
  }

  get curl() {
    let headersString = '';
    let paramsString = ``;

    const headers = this.headers;
    const params = this.params;
    for(let name in headers) {
      headersString += `--header '${name}: ${headers[name]}' `;
    }
    for(let name in params) {
      paramsString += `${name}=${params[name]}&`;
    }

    paramsString = paramsString.slice(0, -1);
    const url = this.url;
    let curl = `curl -X POST ${headersString}-d '${paramsString}' '${url}'`;
    return curl;
  }

  get curlParamsString() {
    let paramsString = ``;

    const params = this.params;
    for(let name in params) {
      paramsString += `${name}=${params[name]}&`;
    }
    paramsString = paramsString.slice(0, -1);
    return paramsString;
  }

  get headers() {
    const inputs = this.AllInputsStore.inputs;
    const headerBlock = this.AllInputsBlocksStore.inputsBlocks['headers'];
    const headerInputsName = headerBlock.inputsNames;
    const headersObj = {};
    headerInputsName.forEach((name) => {
      const {label, value, values, type} = inputs[name];
      const lowerCaseLabel = label.toLowerCase();
      if(type === 'select') {
        headersObj[lowerCaseLabel] = values[value];
      } else {
        headersObj[lowerCaseLabel] = value;
      }
    });

    headersObj['sign'] = this.sign;
    return headersObj;
  }

  clearSettings = () => {
    const exclusions = ['clientId'];
    const inputs = this.AllInputsStore.inputs;
    const paramInputNames = this.AllInputsBlocksStore.inputsBlocks.params.inputsNames;
    paramInputNames.forEach((name) => {
      if(exclusions.includes(name)) return;
      if(inputs[name].type === 'select') return;
      this.AllInputsStore.updateInputValue(name, '');
      //this.CookieStore.removeCookie(name);
    });
  };

};

decorate(mainStore, {
  response: observable,
  error: observable,
  isResponsePending: observable,
  stringBeforeHash: computed,
  curlParamsString: computed,
  sign: computed,
  curl: computed,
  userParams: computed,
  stringNoSecretKey: computed,
  btnClassName: computed,
  submitBtnClass: computed,
});

export default new mainStore();
